import React, { useEffect, useState } from "react";

import { useQuery, useLazyQuery } from "@apollo/client";
import { GetDashboardInProgressTasksDocument, GetDashboardInProgressTasksQuery, GetDashboardInProgressTasksReportDocument, GetDashboardInProgressTasksReportQuery } from "../../../../generated/graphql";

import { TableBody, TableRow, CircularProgress, Table } from "@material-ui/core";

import { CustomTable } from "../../../shared/CustomTable";

import { LoadingBox } from "../../../shared/Style/Style";
import { CustomTableCell, CustomTableHead, CustomTableHeaderCell, CustomTableRow } from "../../../shared/CustomTable/CustomTable.style";
import { Dropdown } from "../../Dropdown";
import { choseOrToggleIdHandler } from "../../../shared/Utils/StateOperations/choseOrToggleId";
import { DropdownArrowButton } from "../../../shared/Buttons/DropdownArrowButton";
import { IDashboardReportProps } from "../../Dashboard";

export const TasksInProgress = ({ dateRange, projectId }: IDashboardReportProps) => {
  const [chosenProjectId, setChosenProjectId] = useState('');

  const [getTasks, {
    data: tasksData,
    loading: tasksLoading,
    error: tasksError,
  }] = useLazyQuery<GetDashboardInProgressTasksQuery>(
    GetDashboardInProgressTasksDocument, {
      fetchPolicy: 'cache-and-network'
    }
  );

  useEffect(() => {
    if (chosenProjectId) {
      getTasks({
        variables: {
          projectId: chosenProjectId,
          status: 'indeterminate'
        }
      });
    }
  }, [chosenProjectId]);

  let tasksList: JSX.Element;

  if (tasksLoading) {
    tasksList = (
      <TableRow>
        <CustomTableCell colSpan={2}>
          <LoadingBox>
            <CircularProgress color='inherit'/>
          </LoadingBox>
        </CustomTableCell>
      </TableRow>
    )
  }

  if (tasksError) {
    tasksList = (
      <TableRow>
        <CustomTableCell colSpan={2}>
          Не удалось загрузить данные
        </CustomTableCell>
      </TableRow>
    )
  }

  if (tasksData) {
    const tasks = tasksData.getProjectTasks;

    tasksList = <Dropdown type='task' items={tasks} />
  }

  const { data, loading, error } = useQuery<GetDashboardInProgressTasksReportQuery>(
    GetDashboardInProgressTasksReportDocument, {
      variables: {
        projectId,
        ...dateRange
      },
      fetchPolicy: 'cache-and-network'
    }
  );

  let content;

  if (loading) {
    content = (
      <TableBody>
        <TableRow>
          <CustomTableCell>
            <LoadingBox>
              <CircularProgress color='inherit'/>
            </LoadingBox>
          </CustomTableCell>
        </TableRow>
      </TableBody>
    )
  }

  if (error) {
    content = (
      <TableBody>
        <TableRow>
          <CustomTableCell>
            Не удалось загрузить данные
          </CustomTableCell>
        </TableRow>
      </TableBody>
    )
  }

  if (data) {
    const projects = data.getDashboardInProgressTasksReport;

    content = (
      <TableBody>
        {projects.length
          ? projects.map(project => (
            <React.Fragment key={project.projectId}>
              <CustomTableRow
                clickable={true}
                onClick={() => choseOrToggleIdHandler(project.projectId, chosenProjectId, setChosenProjectId)}
              >
                <CustomTableCell width={100}>
                  {project.projectName}

                  <DropdownArrowButton expanded={project.projectId === chosenProjectId}/>
                </CustomTableCell>

                <CustomTableCell width={100}>
                  {project.tasksCount}
                </CustomTableCell>
              </CustomTableRow>

              {(project.projectId === chosenProjectId) && tasksList}
            </React.Fragment>
          ))
          : (
            <TableRow>
              <CustomTableCell>
                Не удалось загрузить данные
              </CustomTableCell>
            </TableRow>
          )
        }
      </TableBody>
    )
  }

  const table = (
    <Table>
      <CustomTableHead>
        <TableRow>
          <CustomTableHeaderCell colSpan={2} >
            В процессе
          </CustomTableHeaderCell>
        </TableRow>
      </CustomTableHead>

      {content}
    </Table>
  )

  return (
    <>
      <CustomTable data={data?.getDashboardInProgressTasksReport} tableContent={table} height={247}/>
    </>
  )
}